import React from "react";
import { Link, NavLink } from "react-router-dom";

export default function UserPanelHeader(props) {
  return (
    <>
      <div className="container-fluid p-0 user-panel-header">
        <div className="row app-container justify-content-center align-items-center">
          <div className="col-6 details-side">
            <h1 className="fw-bold text-capitalize">Welcome {props.userName}</h1>
            <div className="account-email">
              <p className="m-0 mb-1 account-email-title">Account Email</p>
              <p className="fw-medium account-email-value">
                {props.userEmail}
              </p>
            </div>
          </div>
          <div className="col-6 image-side">
            <div className="profile-pic ms-auto position-relative" style={{background : `url(${props.userImg ? props.userImg : ""})`}}>
              <div className="update-profile-pic d-flex justify-content-center align-items-center">
                <i className="fa-solid fa-pen"></i>
                <input
                  type="file"
                  name="user_img"
                  className="profile-pic-input"
                  onChange={props.userImgHandler}
                />
              </div>
            </div>
          </div>

          {/* User Panel Tabs Start */}
          <div className="col-12 p-0 userPanelTabs d-flex gap-sm-5 gap-4 align-items-center">
            <NavLink to="/my-account" className={(({ isActive }) => (isActive ? 'tabActive' : 'inactive'))}>Account</NavLink>
            <NavLink to="/my-bookings" className={(({ isActive }) => (isActive ? 'tabActive' : 'inactive'))}>
              Bookings
            </NavLink>
          </div>
          {/* User Panel Tabs End */}
        </div>
      </div>
    </>
  );
}
